/*
 * @Author: cryi.liu
 * @Date: 2020-04-29 17:29:59
 * @LastEditTime: 2020-06-15 11:17:45
 * @Description: 路由配置出口
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import examRoute from './modules/examRoute';
import toolsRoute from './modules/toolsRoute';

Vue.use(VueRouter);

const routes = [
  ...examRoute,
  ...toolsRoute,
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
